export function getTrackingEnv() {
  let envLanguage = 'en';
  if (window.location.pathname.includes('/fr/')) envLanguage = 'fr';
  if (window.location.pathname.includes('/es/')) envLanguage = 'es';
  const envWork = window.location.host === 'payfit.com' ? 'Prod' : 'Dev';
  return {
    envLanguage,
    envWork,
  };
}
